<template>
  <section>
    <section class="hero is-medium is-primary is-bold">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h2 class="title">
            Our Mission
          </h2>
          <h3 class="subtitle">
            <p>
              At Chinchilla Essentials, our goal is to educate new chinchilla
              owners on the most critical aspects of ownership.
            </p>
            <br />
            <p>
              Chinchillas are unique animals that require very special care with
              regards to diet, housing, and overall health. By providing advice
              and <strong>safe</strong> product suggestions, we strive to help
              cultivate a safe and loving environment for Floofs all around the
              globe.
            </p>
          </h3>
        </div>
      </div>
    </section>

    <main role="main" class="container section">
      <div class="content has-text-centered">
        <h1 class="title">About Us</h1>
        <p>
          We're just two brothers with a passion for web development and
          chinchillas
        </p>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent is-6">
          <div class="tile is-child card">
            <div class="card-content">
              <div class="media person-card-header">
                <div class="media-left">
                  <figure class="image is-96x96">
                    <img
                      class="is-rounded"
                      src="../assets/angelo.jpeg"
                      alt="Angelo"
                    />
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">Angelo Cicero</p>
                  <p class="subtitle is-6">
                    <a href="www.linkedin.com/in/angelocicero" target="_blank"
                      >LinkedIn</a
                    >
                  </p>
                </div>
              </div>
              <div class="content">
                Web developer, music composer, chinchilla advocate.
              </div>
            </div>
          </div>
        </div>
        <div class="tile is-parent is-6">
          <div class="tile is-child card">
            <div class="card-content">
              <div class="media person-card-header">
                <div class="media-left">
                  <figure class="image is-96x96">
                    <img
                      class="is-rounded"
                      src="../assets/antonio.jpeg"
                      alt="Antonio"
                    />
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">Antonio Cicero</p>
                  <p class="subtitle is-6">
                    <a
                      href="https://www.linkedin.com/in/antonio-cicero-3821a0a7/"
                      target="_blank"
                      >LinkedIn</a
                    >
                  </p>
                </div>
              </div>
              <div class="content">
                Web developer, world explorer, chinchilla advocate.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content has-text-centered">
        <h3 class="title">Contributors</h3>
        <p>Special thanks to the following contributors to the site!</p>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent is-6">
          <div class="tile is-child card">
            <div class="card-content">
              <div class="media person-card-header">
                <div class="media-left">
                  <figure class="image is-96x96">
                    <img
                      class="is-rounded"
                      src="../assets/kayla.jpeg"
                      alt="Kayla"
                    />
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">Kayla Ouyang</p>
                  <p class="subtitle is-6">
                    <a
                      href="https://www.linkedin.com/in/kayla-ouyang-data-analytics/"
                      target="_blank"
                      >LinkedIn</a
                    >
                  </p>
                </div>
              </div>
              <div class="content">
                Piano wizard, data guru, chinchilla advocate.
              </div>
            </div>
          </div>
        </div>
        <div class="tile is-parent is-6">
          <div class="tile is-child card">
            <div class="card-content">
              <div class="media person-card-header">
                <div class="media-left">
                  <figure class="image is-96x96">
                    <img
                      class="is-rounded"
                      src="../assets/rena.jpg"
                      alt="Rena"
                    />
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">Rena Ouyang</p>
                </div>
              </div>
              <div class="content">
                Content writer, proud parent to a chinchilla named Cheerio.
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { getPageMeta } from '@/utils'

const meta = {
  pageTitle: 'About Us',
  pageDescription:
    'At Chinchilla Essentials, our goal is to educate new chinchilla owners on the most critical aspects of ownership. Chinchillas are unique animals that require very special care with regards to diet, housing, and overall health.',
  pageURL: 'http://www.chinchillaessentials.com/about',
  pageImg:
    'https://www.chinchillaessentials.com/img/chinchilla_baby_and_mother.jpeg'
}

export default {
  name: 'About',
  metaInfo: () => getPageMeta(meta)
}
</script>

<style lang="scss" scoped>
.person-card-header {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
